import { LocaleEnum } from '@systemeio/ui'
import useUser from 'shared/hooks/use-user'
import { HelpScout } from './help-scout'
import { BoldDesk } from './bolddesk'
import { isSioHost, isClient } from '@systemeio/util'

const newBotLocales: LocaleEnum[] = []

export function HelpBots() {
  const { user } = useUser()
  if (!user) return null

  const isDev = process.env.NEXT_PUBLIC_APP_ENV === 'development'
  if (isDev) return null

  const isSio = isClient() ? isSioHost(window.location.host) : false
  if (!isSio) return null

  const useNewBot = newBotLocales.includes(user.dashboardLocale)
  return (
    <>
      <HelpScout shouldRender={!useNewBot} locale={user.dashboardLocale} />
      <BoldDesk shouldRender={useNewBot} locale={user.dashboardLocale} />
    </>
  )
}
